
module.exports = {
    header: {
        dashboard: 'Dashboard',
        task: 'Tasks',
        components: 'components',
        schedule: 'Schedule',
        flies: 'Flies',
        map: 'Map',
        flowEditor: 'Flow Editor',
        keepAlive: 'Keep Alive',
        login: 'Login Page'
    },
    task: {
        title: 'My task'
    },
    files: {
        title: 'files',
        btn: 'Upload excel '
    }


};
